import React from 'react';
import PropTypes from 'prop-types';

import Header from '../../../../components/global/Header';
import Logo from '../../../../components/global/Logo';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
    display_name: PropTypes.string,
  }),
};

const CustomPrintsConfiguratorViewHeader = ({ album }) => (
  <Header>
    <div className="site-brand">
      <Logo
        linksTo={album ? `/purchase/album/${album.id}` : undefined}
        iconOnly
      />
    </div>

    <h3 className="site-title-center">Choose your photos</h3>
  </Header>
);

CustomPrintsConfiguratorViewHeader.propTypes = propTypes;

export default CustomPrintsConfiguratorViewHeader;
